import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateConfigurationsState from './configuration';

export default (state = initialState, action) => chooseReducer(state, action, updateConfigurationsState);
